import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=5d5ebd64&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=5d5ebd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ebd64",
  null
  
)

export default component.exports